// extracted by mini-css-extract-plugin
export default {"toggleDemo":"ToggleDemo_toggleDemo__OWmJC","title":"ToggleDemo_title__a54UA","subtitle":"ToggleDemo_subtitle__0IrKe","btn":"ToggleDemo_btn__xt6ps"};